<script setup>
import Articles from '@/components/Articles.vue'
import TagArea from '@/components/TagArea.vue'

const route = useRoute()
const tagSlug = route.params.slug
</script>

<template>
  <div class="px-vw6">
    <TagArea class="hidden lg:block" :current-tag="tagSlug" />
    <Articles :tag="tagSlug" />
  </div>
</template>